import { extendTheme } from '@chakra-ui/react'
import { customTheme } from '#/src/styles/customTheme'

export const landingTheme = extendTheme(customTheme, {
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false
  }
})
